import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorFlagTitle: {
		id: 'software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.error-flag-title',
		defaultMessage: "Can't move this issue to another version",
		description: 'Flag title for failure to move issue',
	},
	errorFlagDescription: {
		id: 'software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.error-flag-description',
		defaultMessage: "We couldn't move {issueKey} to {versionName}. Please try again.",
		description: 'Flag description for failure to update version description',
	},
	successFlagDescription: {
		id: 'software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.success-flag-description',
		defaultMessage: '{issueKey} has been moved to {versionName}.',
		description: 'Flag message when issue successfully added',
	},
	missingResolvePermissionErrorgFlagDescription: {
		id: 'software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.missing-resolve-permission-errorg-flag-description',
		defaultMessage:
			"You don't have permission to resolve {issueKey}, so you can't move it to another version.",
		description:
			'Flag message when issue could not be moved to the version as the user does not have resolve issue permission',
	},
	missingEditPermissionErrorFlagDescription: {
		id: 'software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.missing-edit-permission-error-flag-description',
		defaultMessage:
			"You don't have permission to edit {issueKey}, so you can't move it to another version.",
		description:
			'Flag message when issue could not be moved to the version as the user does not have edit issue permission',
	},
	missingPermissionsErrorFlagDescription: {
		id: 'software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.missing-permissions-error-flag-description',
		defaultMessage:
			"You don't have permission to edit or resolve {issueKey}, so you can't move it to another version.",
		description:
			'Flag message when the selected issue could not be moved as the user does not have both resolve and edit permissions ',
	},
});
